import React, { useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Lock } from 'lucide-react';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { confirmPasswordReset } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      await confirmPasswordReset(token, password);
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="reset-password-page">
      <div className="auth-card">
        <div className="auth-header">
          <Lock className="auth-icon" size={32} />
          <h2 className="auth-title">Set New Password</h2>
          <p className="auth-subtitle">Enter your new password</p>
        </div>
        
        {success ? (
          <div className="auth-success" data-testid="reset-complete">
            <p>Password reset successful! Redirecting to login...</p>
          </div>
        ) : (
          <>
            {error && <div className="auth-error" data-testid="reset-error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-form-group">
                <label htmlFor="password" className="auth-label">New Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="auth-input"
                  data-testid="password-input"
                  placeholder="••••••••"
                  minLength="8"
                  required
                />
                <p className="auth-hint">
                  Must contain uppercase, lowercase, and number
                </p>
              </div>
              <div className="auth-form-group">
                <label htmlFor="confirmPassword" className="auth-label">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="auth-input"
                  data-testid="confirm-password-input"
                  placeholder="••••••••"
                  minLength="8"
                  required
                />
              </div>
              <button 
                type="submit" 
                disabled={loading}
                className="auth-button"
                data-testid="reset-submit-button"
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
        
        <p className="auth-link-text">
          <Link to="/login" className="auth-link">Back to Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
